import { useSSRData } from 'hooks';
import { getFamilies } from 'utils';
import getFirstCorrectData from './utils';

const useColorFamilies = () => {
    const state = useSSRData();
    const colorFamilies = getFirstCorrectData(
        state.colorFamilies,
        getFamilies(),
        {},
    );

    const getFamilyColorByName = name =>
        typeof name === 'string' && colorFamilies
            ? colorFamilies[name.toLowerCase()]
            : undefined;

    const getFamilyNameByColor = color => {
        const [name] =
            Object.entries(colorFamilies).find(family => family[1] === color) ||
            [];
        return name;
    };

    const doesColorExist = color => !!getFamilyColorByName(color);

    return {
        getFamilies,
        getFamilyColorByName,
        getFamilyNameByColor,
        doesColorExist,
    };
};

export default useColorFamilies;
